/*
 *
 * SubscriptionPlans constants
 *
 */

export const FETCH_SUBSCRIPTION_PLANS =
  'app/SubscriptionPlans/FETCH_SUBSCRIPTION_PLANS';
export const FETCH_SUBSCRIPTION_PLANS_SUCCESS =
  'app/SubscriptionPlans/FETCH_SUBSCRIPTION_PLANS_SUCCESS';
export const FETCH_SUBSCRIPTION_PLANS_FAILED =
  'app/SubscriptionPlans/FETCH_SUBSCRIPTION_PLANS_FAILED';

export const BILLING_IDS = {
  annually: 'Yearly',
  yearly: 'Yearly',
};

export const BILLING_NAMES = {
  yearly: 'Annually',
  annually: 'Annually',
  month: 'Monthly',
  quarter: 'Quarterly',
  year: 'Annually',
};

export const BILLING_DURATIONS = {
  monthly: 'month',
  quarterly: 'quarter',
  yearly: 'year',
  annually: 'year',
};

export const SUBSCRIPTION_STATE = {
  upgrade: 'UPGRADE',
  downgrade: 'DOWNGRADE',
  cancel: 'CANCEL',
  subscribe: 'SUBSCRIBE',
  reEnable: 'RE_ENABLE',
};

export const PLAN_NAMES = {
  basic: 'basic',
  pro: 'pro',
  enterprise: 'enterprise',
  elite: 'elite',
};

export const PLAN_DESCRIPTIONS = {
  basic: 'Best for small businesses',
  pro: 'Best for small teams and agencies',
  elite: 'Best for high-growth startups + enterprises',
};
export const PLAN_COSTS = {
  pro: 15000,
  elite: 50000,
};

export const PRICING_PLANS_FEATURES = [
  {
    name: 'Basic',
    features: {
      values: [
        '14 advanced question types',
        '3 screening questions',
        'A/B testing',
        '50 survey questions per survey',
        'Data Exports (SPSS, EXCEL, CSV, PDF, CROSSTAB)',
        'Demographic information on results',
        'Open ended results grouping',
        '10% IR (no premium)',
        'Link Distribution',
        '24/7 support',
      ],
    },
  },
  // {
  //   name: 'Pro',
  //   features: {
  //     values: [
  //       '6 screening question',
  //       'Crosstab designer',
  //       'Conjoint analysis',
  //       'Van Westendorp',
  //       'Max Diff',
  //       'Live BigQuery export',
  //       '5% IR (no premium)',
  //       '2x survey priority (faster)',
  //       'Dedicated Account Manager',
  //       'Complete team onboarding',
  //       'Language translations',
  //       'Ad-hoc trainings',
  //       'Single Sign-on(SSO)',
  //       'Unlimited seats',
  //       'Account budgets',
  //     ],
  //   },
  //   prodegeServices: {
  //     title: 'Provided by Prodege Peeq',
  //     features: {
  //       values: [
  //         'Geofencing entry/exit surveys',
  //         'Shopper receipt surveys',
  //         'Web visit/buyer surveys',
  //         'In-home use surveys',
  //         'Brand tracker surveys',
  //         'Retargeting surveys',
  //         'Ad effectiveness surveys',
  //         'Mobile mission surveys',
  //         'Image/video surveys',
  //         'Research consulting',
  //         'Survey programming',
  //         'Data coding & processing',
  //         'Translation services',
  //         'Analysis & insight generation',
  //         'Online bulletin boards',
  //         'Video diaries',
  //         'Live session chats',
  //         'Text chats',
  //         'Short-term communities',
  //         'Interactive dashboards',
  //         'Export rich visuals in one click',
  //         'Automated reports',
  //         'Custom branding',
  //         'Advanced analysis',
  //       ],
  //     },
  //   },
  //   price: 15000,
  // },
  {
    name: 'Elite',
    features: {
      values: [
        'Volume discounts',
        '5% IR (no premium)',
        '2x survey priority (faster)',
        '6 screening questions',
        'Conjoint analysis',
        'MaxDiff analysis',
        'Van Westendorp (PSM)',
        'Custom survey themes',
        'Crosstab designer',
        'Live BigQuery export',
        'Language translations',
        'Single Sign-on (SSO)',
        'Unlimited seats',
        'Account budgets',
        'Dedicated Account Manager',
        'Complete team onboarding',
        'Ad-hoc trainings',
        'Quarterly survey meetings',
      ],
    },
    prodegeServices: {
      title: 'Access to Services Team and these Additional Features',
      addStar: true,
      addStarMessage: 'Additional costs apply',
      features: {
        values: [
          'Geofencing entry/exit surveys',
          'Shopper receipt surveys',
          'Web visit/buyer surveys',
          'In-home use surveys',
          'Brand tracker surveys',
          'Retargeting surveys',
          'Ad effectiveness surveys',
          'Mobile mission surveys',
          'Image/video surveys',
          'Research consulting',
          'Survey programming',
          'Data coding & processing',
          'Translation services',
          'Analysis & insight generation',
          'Online bulletin boards',
          'Video diaries',
          'Live session chats',
          'Text chats',
          'Short-term communities',
          'Interactive dashboards',
          'Export rich visuals in one click',
          'Automated reports',
          'Custom branding',
          'Advanced analysis',
        ],
      },
    },
    price: 50000,
  },
];
